import DefaultStorageService from '@/services/default-storage-service';
import SecureStorageService from '@/services/secure-storage-service';

const storage = new DefaultStorageService();

const secureStorage = new SecureStorageService();

export { storage, secureStorage };
